import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'cms_article_simple',
  components: {
    Editor: function Editor() {
      return import("@/components/editor.vue");
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '简易文章',
        addFunName: 'cmsArticleSimpleAdd',
        modifyFunName: 'cmsArticleSimpleModify',
        delFunName: 'cmsArticleSimpleDel',
        queryFunName: 'cmsArticleSimpleQuery',
        detailFunName: 'cmsArticleSimpleDetail',
        onlineFunName: 'cmsArticleSimpleOnline',
        unOnlineFunName: 'cmsArticleSimpleUnOnline',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      dicData: {
        categoryUpperCode: 'cms_article_category',
        configCategorys: [],
        configCategoryOptions: {},
        typeUpperCode: 'cms_article_type',
        configTypes: [],
        configTypeOptions: {}
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        title: null,
        code: null,
        category: null,
        type: null,
        author: null,
        coverImage: null,
        carousel: null,
        viewsCount: null,
        content: null,
        onlineState: false,
        codeNotBlank: true
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.categoryUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configCategorys = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configCategoryOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.typeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configTypes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configTypeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    online: function online(id) {
      var _this2 = this;
      this.$confirm('确定要上架吗').then(function () {
        _this2.$api[_this2.pageConfig.onlineFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('上架成功');
            _this2.query();
          } else {
            _this2.$message.error('上架失败');
          }
        });
      });
    },
    unOnline: function unOnline(id) {
      var _this3 = this;
      this.$confirm('确定要下架吗').then(function () {
        _this3.$api[_this3.pageConfig.unOnlineFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('下架成功');
            _this3.query();
          } else {
            _this3.$message.error('下架失败');
          }
        });
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      this.formData.codeNotBlank = !!paramData.code;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this4.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this4.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this4.formData.coverImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.coverImage);
    },
    removeFile: function removeFile() {
      this.formData.coverImage = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this5 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this5.initFormData(res.data);
        _this5.editDialogTitle = _this5.pageConfig.editPageName + '维护';
        _this5.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this6 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this6.$api[_this6.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this6.$message.success('删除成功');
            _this6.query();
          } else {
            _this6.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this7 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this7.tableData = res.data || [];
        _this7.totalCount = res.count;
        _this7.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this8 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this8.formData.id) {
            _this8.$api[_this8.pageConfig.modifyFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
              if (res.data) {
                _this8.$message.success('编辑成功');
                _this8.initFormData(_this8.emptyFormData);
                _this8.editDialogShow = false;
                _this8.query();
              } else {
                _this8.$message.error('编辑失败');
              }
            });
          } else {
            _this8.$api[_this8.pageConfig.addFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
              if (res.data) {
                _this8.$message.success('新增成功');
                _this8.initFormData(_this8.emptyFormData);
                _this8.editDialogShow = false;
                _this8.query();
              } else {
                _this8.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};